<template>
  <div style="display: flex; flex-direction: column; margin: 20px">
    <v-data-table
      :headers="visibleHeaders"
      :items="items"
      style="width: 100%"
      :footer-props="{
        'items-per-page-options': [5, 20, 50, 100, -1],
        'items-per-page-text': this.$t('_lignes_par_page_'),
      }"
      :items-per-page="5"
      :item-key="'id'"
      :single-expand="true"
      :expanded.sync="alarmExpanded"
      show-expand
      dense
    >
      <template v-slot:item.cat_checklist="{ item }">
        <icon
          v-if="item.cat_checklist"
          :icon="getIconifyIcon(item.cat_checklist)"
          :height="20"
          :color="'#000'"
        />
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
            <ul class="mx-0 my-2" style="line-height: 1.25rem">
              <li
                v-for="msg in splitBySeparator(item.message, '\n')"
                :key="msg"
              >
                {{ msg }}
              </li>
            </ul>
          </td>
      </template>
    </v-data-table>
    <!--<v-btn style="width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>-->
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon,
  },
  props: {
    liste_alarmes: {
      type: Array,
      required: true,
    },
    activeButton: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      alarmExpanded: [],
    };
  },
  computed: {
    visibleHeaders() {
      // Adjust the headers based on which button is active
      if (this.activeButton === 2) {
        return this.headers;
      } else {
        // Show reduced headers for evolution
        return this.headers.slice(0, 5); // For example, show only the first 5 headers
      }
    },
  },
  watch: {
    liste_alarmes(newVal) {
      this.items = [];
      this.items = newVal.map((alarm, index) => ({
        id: index, // Ensure each item has a unique id (or use a specific unique identifier from your data)
        message: alarm.message,
        site: alarm.site,
        cat_checklist: alarm.icon,
        checklist_desc: alarm.checklist_desc,
        icon_height: alarm.icon_height,
        criticity: alarm.criticity,
        status: alarm.status,
        open_date: alarm.open_date,
        pertes: alarm.pertes,
        cost: alarm.cost,
        loss_frac: alarm.loss_frac,
      }));
    },
    activeButton: {
      handler() {
        this.visibleHeaders();
      },
    },
    "$root.$i18n.locale": {
      async handler() {
        await this.refresh_header_values();
      },
      immediate: true,
    },
  },
  created() {
    this.items = [];
    if (this.liste_alarmes.length > 0) {
      this.items = this.liste_alarmes.map((alarm, index) => ({
        id: index, // Ensure each item has a unique id
        message: alarm.message,
        site: alarm.site,
        cat_checklist: alarm.icon,
        checklist_desc: alarm.checklist_desc,
        icon_height: alarm.icon_height,
        criticity: alarm.criticity,
        status: alarm.status,
        open_date: alarm.open_date,
        pertes: alarm.pertes,
        cost: alarm.cost,
        loss_frac: alarm.loss_frac,
      }));
    }
  },
  methods: {
    splitBySeparator(item, sep) {
      if (item !== undefined) {
        return item.substring(0, item.length - 1).split(sep);
      } else {
        return "";
      }
    },
    refresh_header_values() {
      this.headers = [
        { text: this.$t("_site_"), value: "site" },
        {
          text: this.$t("_categorie_"),
          align: "start",
          sortable: false,
          value: "cat_checklist",
        },
        { text: this.$t("_sub_categorie_"), value: "checklist_desc" },
        { text: this.$t("_criticite_"), value: "criticity" },
        { text: this.$t("_date_d_ouverture_"), value: "open_date" },
        { text: this.$t("_statut_"), value: "status" },
        { text: this.$t("_pertes_kwh_"), value: "pertes" },
        { text: this.$t("_cout_"), value: "cost" },
        { text: this.$t("_pertes_frac_"), value: "loss_frac" },
      ];
    },

    getIconifyIcon(iconString) {
      // Assuming iconString is in the format like 'iconoir:sine-wave'
      const [library, iconName] = iconString.split(":"); // Split library and icon name
      if (library === "tabler") {
        return `tabler:${iconName}`;
      } else if (library === "iconoir") {
        return `iconoir:${iconName}`;
      } else if (library === "carbon") {
        return "carbon:data-blob";
      } else if (library === "game-icons") {
        return `game-icons:${iconName}`;
      } else {
        return null;
      }
    },
    formatMessage(message) {
      if (!message) return "";

      // Split into lines and remove empty ones
      const lines = message.split(/\r?\n/).filter((line) => line.trim() !== "");

      if (lines.length === 0) return message;

      // Check if the first line looks like HTML (a heading or <b> tag)
      const firstLine = lines[0];
      const hasHtmlHeading = /<h\d>|<b>/i.test(firstLine);

      let title = "";
      let listStartIndex = 0;

      if (hasHtmlHeading) {
        // Use it as-is
        title = firstLine;
        listStartIndex = 1;
      }  else {  
        return `<li>${lines[0]}</li>`;
      }

      // Wrap remaining lines as list items
      const listItems = lines
        .slice(listStartIndex)
        .map((line) => `<li>${line}</li>`)
        .join("");

      return `
    <div>
      ${title}
      ${listItems ? `<ul>${listItems}</ul>` : ""}
    </div>
  `;
    },
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  font-size: 0.75rem;
  height: 45px;
  line-height: 1.2;
}
#sys_acq > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#env_res > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#inv > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#field_mod > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#alm_inc > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2) {
  height: 50px;
  vertical-align: middle;
  background-color: #f7f7f7;
}

.table-text {
  font-family: Roboto, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: left;
}

.text-subtitle-3 {
  font-size: 0.775rem !important;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0.0071428571em !important;
  font-family: Roboto, sans-serif !important;
  color: grey;
}
.message-content ul {
  margin-top: 4px;
  margin-bottom: 0;
  padding-left: 20px;
  list-style-type: disc; /* standard bullets */
}

.message-content li {
  line-height: 1.3rem;
  margin-bottom: 4px;
}

.message-content h3 {
  margin-bottom: 6px;
  font-weight: bold;
}
</style>
